import React, { useEffect } from 'react';
import {
  Button,
  Card,
  CardHeader
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReimbursementStore from '../stores/ReimbursementStore';

const closeModal = () => {
  ReimbursementStore.setOpenModal();
}

const resetForm = () => {
  ReimbursementStore.clearReimbursementForm();
}

const ErrorWindowComponent = props => {

  const {
    errorCount
  } = props;

  return (
    <>
      <Card>
        <CardHeader className="errorPopup d-flex justify-content-center flex-column align-items-center center-text poppins-font">
          {
            errorCount > 0 ?
              <>
                <h5>
                  <b>
                    The FCS TAP Reimbursement Request Form has failed to send.
                </b>
                </h5>
                {
                  ReimbursementStore.reqFieldsValidationCheck && (
                    <div className="response-errors">
                      <h6>Please Enter all the Required Fields</h6>
                      <h6>Please Enter all the Requried Date Fields using the Date Picker</h6>
                    </div>
                  )
                }
                {
                  ReimbursementStore.responseErrors.length > 0 && (
                    ReimbursementStore.responseErrors.map(responseError => (
                      <div className="response-errors">
                        <h6>{`${responseError.message}`}</h6>
                      </div>
                    )
                    )
                  )
                }
                <div className="spacer" />
                <h6>Hit <b>submit</b> again</h6>
                <Button className="errCloseBtn" onClick={() => closeModal()} type="button" color="default">
                  OK
              </Button>
              </>
              :
              <>
                <h5>
                  <b>
                    The FCS TAP Reimbursement Request Form has failed to send.
                </b>
                </h5>
                {
                  ReimbursementStore.reqFieldsValidationCheck && (
                    <div className="response-errors">
                      <h6>Please Enter all the Required Fields</h6>
                      <h6>Please Enter all the Requried Date Fields using the Date Picker</h6>
                    </div>
                  )
                }
                {
                  ReimbursementStore.responseErrors.length > 0 && (
                    ReimbursementStore.responseErrors.map(responseError => (
                      <div className="response-errors">
                        <h6>{`${responseError.message}`}</h6>
                      </div>
                    )
                    )
                  )
                }
                <div className="spacer" />
                <h6>Please try again sometime later.</h6>
                <NavLink exact to="/" onClick={() => resetForm()} className="btn errCloseBtn btn-default">
                  OK
              </NavLink>
              </>
          }
        </CardHeader>
      </Card>
    </>
  )
}

ErrorWindowComponent.propTypes = {
  errorCount: PropTypes.number
}

export default ErrorWindowComponent;